module.exports = __webpack_public_path__ + "static/media/W-LOGO-ESP.65f9248a.png";